import { Group, Stack, Title, Text } from '@mantine/core';
import cx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useMedia } from '@mygpt/app';
import classes from './index.module.css';
import { AnimateDiv } from '@/components/Common/AnimateDiv';

const Home = () => {
  const { t } = useTranslation('', { lng: 'ja' });
  const { isMobile } = useMedia();

  const isDev = ['development', 'pre'].includes(import.meta.env.VITE_STAGE);

  return (
    <section className="flex flex-col mt-[80px] max-h-[1440px] max-w-[1520px] mx-auto px-[20px] lg:px-[80px]">
      <AnimateDiv className="space-y-6">
        <Group className="flex-col md:flex-row md:flex-nowrap md:justify-around">
          <Stack gap="lg" className="lg:justify-center">
            <Title order={1} className="text-4xl sm:text-6xl lg:text-[68px] font-bold leading-tight">
              GBase Support
            </Title>
            <Stack className="mt-10">
              <Title order={2} className="text-2xl sm:text-3xl lg:text-4xl font-bold">
                AIナレッジエージェントで
              </Title>
              <Title order={2} className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-loose">
                社内外の問い合わせ対応を
                <span className="bg-violet-500/20 rounded-l-[16px] px-4 relative whitespace-nowrap">
                  自動化
                  <span
                    className={cx(
                      classes.blink,
                      'absolute lg:w-[5px] w-[2px] lg:h-[45px] h-[30px] sm:h-[36px] rounded-br-[10px] rounded-bl-[10px] bg-violet-500 lg:top-[-1px] top-[0px] lg:right-[-4px] right-[-2px]'
                    )}
                  ></span>
                  <span className="absolute font-bold lg:w-[68px] w-[36px] lg:top-[-32px] top-[-18px] lg:right-[-67px] right-[0px] lg:rounded-tl-[10.65px] lg:rounded-tr-[10.65px] lg:rounded-br-[10.65px] lg:rounded-bl-[0px] rounded-tl-[8px] rounded-tr-[8px] rounded-br-[0px] rounded-bl-[8px] bg-violet-500 lg:text-lg text-[10px] lg:leading-[32px] leading-[16px] text-white text-center">
                    <span>GBase</span>
                  </span>
                </span>
              </Title>
            </Stack>
            <Text className="text-sm lg:text-lg mt-4 leading-7">
              FAQなどからAIを学習させ、オンラインでの問い合わせ対応を自動化する
              <br />
              多言語・音声・アバター対応可能なAIボットサービス。
              <br />
              社内・顧客の問い合わせを24時間365日サポートを実現します。
            </Text>
          </Stack>
          <Group justify="center" className="digital-human w-full sm:w-2/3 lg:w-1/3 h-[600px]">
            <iframe
              src={
                isDev
                  ? 'https://dev.gbase.ai/widget-page/ccb84b14-4f5b-4118-917a-0a8a1f37a397?noWidgetFooter'
                  : 'https://gbase.ai/widget-page/3412e297-d8c1-4c27-acf8-e32b8338be7b?noWidgetFooter'
              }
              className="w-full max-w-[500px] h-full"
              allow="microphone; autoplay;"
            ></iframe>
          </Group>
        </Group>
      </AnimateDiv>
    </section>
  );
};

export default Home;
